const pluginId = "catalog";

export { pluginId };
//# sourceMappingURL=pluginId.esm.js.map
